import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatMenuModule,
  MatSidenavModule,
  MatToolbarModule,
} from '@angular/material';
import { RouterModule } from '@angular/router';

import { DrawerMenuComponent } from './drawer-menu/drawer-menu.component';
import { HeaderComponent } from './header/header.component';
import { MainComponent } from './main/main.component';
import { Alert } from './modals/alert/alert';

@NgModule({
  declarations: [
    Alert,
    MainComponent,
    HeaderComponent,
    DrawerMenuComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
  ],
  entryComponents:[
    Alert
  ],
  exports: [
    MainComponent,
    HeaderComponent,
    DrawerMenuComponent
  ],
})
export class CoreModule { }
